export const setHueHSL = (curr, hue) => {
  const curr_arr = curr
    .substring(4, curr.length - 2)
    .replace("%", "")
    // .replace("%", "")
    .split(",");
  console.log(curr_arr);
  return `hsl(${hue},${curr_arr[1]}%,${curr_arr[2]}%)`;
};

export const setSaturationHSL = (curr, sat) => {
  const curr_arr = curr
    .substring(4, curr.length - 2)
    .replace("%", "")
    // .replace("%", "")
    .split(",");
  console.log(curr_arr);
  return `hsl(${curr_arr[0]},${sat}%,${curr_arr[2]}%)`;
};

export const setLightnessnHSL = (curr, light) => {
  const curr_arr = curr
    .substring(4, curr.length - 2)
    .replace("%", "")
    .split(",");
  return `hsl(${curr_arr[0]},${curr_arr[1]}%,${light}%)`;
};
